// @vendors
const get = require('lodash/object/get');

// @constants
const actionTypes = require('constants/actionTypes');
const { BROKER_FUND_ORDER_CANCEL } = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;
const { APIPost } = require('utilities/APIRequestHelper');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const { getContractActivities } = require('actions/brokerContractActivities');
const notification = require('actions/notifications');
const errorActions = require('actions/brokerError');

const showError = (error, dispatch, history) => {
    const errorKey = get(error, ["body", "error"], "");
    dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
};

const cancelOrderRequest = () => ({
    type: actionTypes.BROKER_FUND_ORDER_CANCEL_REQUEST
});

const cancelOrderSuccess = () => ({
    type: actionTypes.BROKER_FUND_ORDER_CANCEL_SUCCESS
});

const cancelOrderFailure = error => ({
    type: actionTypes.BROKER_FUND_ORDER_CANCEL_FAILURE,
    payload: {
        error
    }
});

const signaturePatternFailure = () => ({
    type: actionTypes.BROKER_FUND_ORDER_CANCEL_SIGNATURE_FAILURE
});

const cancelOrder = (immOrder, history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const requestData = {
            query: {
                codOperacion: immOrder.get('operationCode'),
                "contrato": {
                    "numerodecontrato": immOrder.get('contractNumber'),
                    "producto": immOrder.get('productNumber')
                },
                dataToken,
                "datosConexion": {},
                "ordenAnulacion": {
                    "codEstado": immOrder.get('stateCode'),
                    "fechaSolicitud": immOrder.get('dateRequested'),
                    "numeroSecuenciaOper": immOrder.get('sequenceNumber')
                },
                "unidades": immOrder.get('units')
            }
        };

        const findContract = () => {
            const brokerJointContracts = getState().brokerJointContracts.get('byId');

            return brokerJointContracts.find(immContract => {
                return immContract.get('walletNumber') === immOrder.get('contractNumber') &&
                    immContract.get('productNumber') === immOrder.get('productNumber');
            });
        }

        dispatch(cancelOrderRequest());
        return APIPost(dispatch, apiURLBuilder.getURL('cancelFundOrder'), requestData)
            .then(
                response => {
                    dispatch(cancelOrderSuccess(response));
                    const message = formatText('broker-fundOrderCancelSuccess');
                    dispatch(notification.success({ message }, { voice: message }));
                    const immContract = findContract();
                    const selectedOption = getState().brokerOrdersAndMovements.get('selectedOption');
                    dispatch(getContractActivities(immContract, selectedOption.get('value'), history));
                },
                response => {
                    showError(response, dispatch, history);
                    dispatch(cancelOrderFailure(response.error.description));
                    const message = formatText('broker-fundOrderCancelFailure');
                    dispatch(notification.error({ message }, { voice: message }));
                }
            )
    };

    const orderType = BROKER_FUND_ORDER_CANCEL;
    const operationParams = {
        originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immOrder.get('productNumber')}${immOrder.get('contractNumber')}`
    };

    dispatch(cancelOrderRequest());
    return dispatch(
        signaturePatternActions.processRequestConfiguration(orderType, operationParams)
    )
        .then(
            () => signaturePatternActions.validateAndExecute(dispatch, getState, callback),
            () => dispatch(signaturePatternFailure())
        );
}

const requestCancelAnOrder = (immOrder, history) => dispatch => {
    dispatch(cancelOrder(immOrder, history));
}

const clearCancelAnOrderData = () => ({
    type: actionTypes.BROKER_FUND_ORDER_CANCEL_CLEAR
});

module.exports = {
    requestCancelAnOrder,
    clearCancelAnOrderData
}
